import React, { useState, useEffect } from 'react'
import { ComparePanAadhaarDataById } from '../../AdminActionCreator.component'
import Loader from '../../../../presentationals/Loader/Loader.component'
import NoData from '../../../../../images/nodata.png'
import Popup from '../../../../presentationals/Popup/Popup.component'

export default function ComparePanAadhaarPopup({ userdata, onClose }) {
    const [loader, setLoader] = useState(false);
    const [popup, setpopup] = useState({ show: false, popupStatus: "" });
    const [compareData, setCompareData] = useState({});

    const closePopup = () => { setpopup({ show: false, popupStatus: "" }) }
    const removePopup = () => { setTimeout(() => { closePopup() }, 5000) }

    useEffect(() => {
        FetchData();
    }, []);

    const FetchData = () => {
        setLoader(true);
        ComparePanAadhaarDataById(userdata?.userId, (callback) => {
            setLoader(false);
            let parsed = callback;
            if (typeof callback === 'string') {
                try {
                    parsed = JSON.parse(callback);
                } catch (e) {
                    console.error("Error parsing comparison data:", e);
                }
            }
            if (parsed && parsed.comparison) {
                setCompareData(parsed);
            } else {
                setpopup({ show: true, popupStatus: "No comparison record found." })
                removePopup()
                setCompareData({});
            }
        });
    };

    const hasData = compareData && compareData.comparison && Object.keys(compareData.comparison).length > 0;
    const comp = compareData.comparison || {};

    // Map fields dynamically handling differing key names (e.g. prefillValue vs panValue)
    const comparisonRows = [
        { 
            label: 'Name', 
            panVal: comp.name?.panValue, 
            aadhaarVal: comp.name?.aadhaarValue, 
            status: comp.name?.status, 
            percentage: comp.name?.percentage 
        },
        { 
            label: 'Date of Birth', 
            panVal: comp.dob?.panValue || comp.dob?.prefillValue, 
            aadhaarVal: comp.dob?.aadhaarValue || comp.dob?.detailsValue, 
            status: comp.dob?.status, 
            percentage: comp.dob?.percentage 
        },
        { 
            label: 'Gender', 
            panVal: comp.gender?.panValue, 
            aadhaarVal: comp.gender?.aadhaarValue, 
            status: comp.gender?.status, 
            percentage: comp.gender?.percentage 
        },
        { 
            label: 'Father Name', 
            panVal: comp.fatherName?.panValue, 
            aadhaarVal: comp.fatherName?.aadhaarValue, 
            status: comp.fatherName?.status, 
            percentage: comp.fatherName?.percentage 
        },
    ].filter(row => row.status);

    return (
        <>
            {popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""}
            
            <style>{`
                .pan-compare-backdrop {
                    position: fixed;
                    inset: 0;
                    background: rgba(15, 23, 42, 0.4);
                    backdrop-filter: blur(12px);
                    z-index: 1050;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .pan-compare-card {
                    background: linear-gradient(145deg, #ffffff, #fbfcfd);
                    border-radius: 20px;
                    border: 1px solid rgba(255, 255, 255, 0.8);
                    box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25);
                    padding: 32px;
                    max-width: 850px;
                    width: 90%;
                    max-height: 85vh;
                    overflow-y: auto;
                    position: relative;
                    color: #1e293b;
                    font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                }
                .pan-compare-close {
                    position: absolute;
                    top: 24px;
                    right: 24px;
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                    border: none;
                    background: #f1f5f9;
                    color: #64748b;
                    font-size: 22px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.2s ease;
                }
                .pan-compare-close:hover {
                    background: #e2e8f0;
                    color: #0f172a;
                    transform: rotate(90deg);
                }
                .pan-compare-title {
                    font-size: 22px;
                    font-weight: 800;
                    margin-bottom: 24px;
                    padding-bottom: 12px;
                    border-bottom: 2px solid #f1f5f9;
                    color: #0f172a;
                    letter-spacing: -0.02em;
                }
                .pan-compare-summary {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 18px 24px;
                    border-radius: 12px;
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;
                    margin-bottom: 24px;
                }
                .pan-compare-score-container {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                }
                .pan-compare-label {
                    font-size: 14px;
                    font-weight: 600;
                    color: #475569;
                }
                .pan-compare-status {
                    font-size: 13px;
                    font-weight: 700;
                    padding: 6px 14px;
                    border-radius: 9999px;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                }
                .pan-compare-status.matched {
                    background-color: #dcfce7;
                    color: #166534;
                    border: 1px solid #bbf7d0;
                }
                .pan-compare-status.not_matched {
                    background-color: #fee2e2;
                    color: #991b1b;
                    border: 1px solid #fca5a5;
                }
                .pan-compare-percentage {
                    font-size: 16px;
                    font-weight: 800;
                    color: #0f172a;
                    background: #f1f5f9;
                    padding: 6px 12px;
                    border-radius: 8px;
                    border: 1px solid #e2e8f0;
                }
                .pan-compare-table-container {
                    width: 100%;
                    overflow-x: auto;
                    border-radius: 12px;
                    border: 1px solid #e2e8f0;
                    background: #ffffff;
                }
                .pan-compare-table {
                    width: 100%;
                    border-collapse: collapse;
                    text-align: left;
                }
                .pan-compare-table th {
                    background: #f8fafc;
                    color: #475569;
                    font-weight: 600;
                    font-size: 12px;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    padding: 14px 18px;
                    border-bottom: 1.5px solid #e2e8f0;
                }
                .pan-compare-table td {
                    padding: 16px 18px;
                    font-size: 13px;
                    color: #334155;
                    border-bottom: 1px solid #f1f5f9;
                    vertical-align: middle;
                }
                .pan-compare-table tr:last-child td {
                    border-bottom: none;
                }
                .field-name {
                    font-weight: 700;
                    color: #1e293b;
                }
                .badge {
                    display: inline-flex;
                    align-items: center;
                    padding: 5px 10px;
                    border-radius: 6px;
                    font-size: 11px;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 0.03em;
                }
                .badge.matched {
                    background-color: #ecfdf5;
                    color: #047857;
                    border: 1px solid #a7f3d0;
                }
                .badge.not_matched {
                    background-color: #fff5f5;
                    color: #e11d48;
                    border: 1px solid #fecdd3;
                }
                .pan-compare-no-data {
                    text-align: center;
                    padding: 48px 24px;
                }
                .pan-compare-no-data-img {
                    max-width: 140px;
                    margin-bottom: 20px;
                    opacity: 0.85;
                }
                .pan-compare-no-data-text {
                    font-size: 16px;
                    font-weight: 600;
                    color: #64748b;
                }
            `}</style>

            <div className="pan-compare-backdrop" onClick={onClose}>
                <div className="pan-compare-card" onClick={(e) => e.stopPropagation()}>
                    <button className="pan-compare-close" onClick={onClose}>
                        &times;
                    </button>
                    <div className="pan-compare-title">PAN vs Aadhaar Data Comparison</div>
                    
                    {loader && <Loader />}
                    
                    {hasData ? (
                        <>
                            {/* Summary Card */}
                            <div className="pan-compare-summary">
                                <span className="pan-compare-label">Verification matching score</span>
                                <div className="pan-compare-score-container">
                                    <span className="pan-compare-percentage">
                                        Match score: {compareData.overallPercentage?.toFixed(2)}%
                                    </span>
                                    <span className={`pan-compare-status ${compareData.overallStatus?.toUpperCase() === 'MATCHED' ? 'matched' : 'not_matched'}`}>
                                        {compareData.overallStatus?.replace('_', ' ')}
                                    </span>
                                </div>
                            </div>

                            {/* Comparison Grid Table */}
                            <div className="pan-compare-table-container">
                                <table className="pan-compare-table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '20%' }}>Field</th>
                                            <th style={{ width: '32%' }}>PAN Value</th>
                                            <th style={{ width: '32%' }}>Aadhaar Value</th>
                                            <th style={{ width: '16%' }}>Match Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {comparisonRows.map((row, index) => {
                                            const isMatch = row.status?.toUpperCase() === 'MATCHED';
                                            const hasScore = row.percentage !== undefined && row.percentage !== null;
                                            return (
                                                <tr key={index}>
                                                    <td className="field-name">{row.label}</td>
                                                    <td>{row.panVal || <span style={{ color: '#94a3b8', fontStyle: 'italic' }}>N/A</span>}</td>
                                                    <td>{row.aadhaarVal || <span style={{ color: '#94a3b8', fontStyle: 'italic' }}>N/A</span>}</td>
                                                    <td>
                                                        <span className={`badge ${isMatch ? 'matched' : 'not_matched'}`}>
                                                            {row.status?.replace('_', ' ')}
                                                            {hasScore && ` (${row.percentage}%)`}
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    ) : (
                        !loader && (
                            <div className="pan-compare-no-data">
                                <img className="pan-compare-no-data-img" src={NoData} alt="No Data" />
                                <div className="pan-compare-no-data-text">No comparison details available.</div>
                            </div>
                        )
                    )}
                </div>
            </div>
        </>
    );
}
